import projectSpecificBundle from '@arg,@demo/i18n/customization.bundle';
import FormSwitcher from './containers/FormSwitcher';
import './styles/styles.scss';
import { buildApp } from '../app';
import PrintView from './views/SummaryView/PrintView';

const url = new URL(window.location.href);
if (url.searchParams.has('printId')) {
  buildApp(PrintView, projectSpecificBundle);
} else {
  buildApp(FormSwitcher, projectSpecificBundle);
}
